<script lang="ts">
	import { getShortAddress } from '$lib/util/util';
	import { overrideWalletAddress, walletAddress } from './store';
	import CopyToClipboard from 'svelte-copy-to-clipboard';

	export let balance: string = 'show';
	export let icon: string = 'hide';
</script>

<div class="sm:flex gap-3">
	{#if $overrideWalletAddress === $walletAddress && $overrideWalletAddress !== ''}
		<CopyToClipboard
			text={$overrideWalletAddress}
			on:copy={() => {
				alert('Copied ' + $overrideWalletAddress);
			}}
			on:fail={() => {
				alert('Failed to copy. Please copy manually ' + $overrideWalletAddress);
			}}
			let:copy
		>
			<button
				class="border border-fx-grey-600 bg-fx-gradient-20 px-2 pt-2 pb-1 rounded-lg squircle-lg text-fx-grey-900 text-sm flex gap-1 font-semibold"
				on:click={copy}
			>
				🕵🏻 : {getShortAddress($walletAddress)}
			</button>
		</CopyToClipboard>
	{/if}
	<w3m-button {balance} {icon} />
</div>
